module.exports = __webpack_public_path__ + "static/media/mbr-1-1920x1280.7822de6a.jpg";